var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnFriendsPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 481",
    style: {
      fill: "none"
    },
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.676 16.247H0v-2.515a4.194 4.194 0 0 1 4.19-4.189h3.351a4.194 4.194 0 0 1 4.19 4.189v2.513h-1.676v-2.513a2.516 2.516 0 0 0-2.514-2.513H4.19a2.516 2.516 0 0 0-2.514 2.513v2.514zm4.189-7.868a4.189 4.189 0 1 1 4.19-4.189 4.194 4.194 0 0 1-4.19 4.189zm0-6.7A2.513 2.513 0 1 0 8.379 4.19a2.516 2.516 0 0 0-2.514-2.514z",
    transform: "translate(14 16.305)",
    style: {
      fill: "#505866"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 11",
    d: "M3.146 8V4.85H0v-1.7h3.146V0h1.706v3.15H8v1.7H4.852V8z",
    transform: "translate(24.73 9)",
    style: {
      fill: "#505866"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFriendsPlus);
export default __webpack_public_path__ + "static/media/icn_friends_plus.da570d12d19dba177e06f388b8ec6cfc.svg";
export { ForwardRef as ReactComponent };